import { Box } from "@mui/material";
import { TabLink, TabLinks } from "components/TabLinks";
import WasteUpsell from "components/UpsellLandingPages/WasteUpsell";
import { FeatureFlagKey } from "encamp-shared/src/featureFlags";
import { useCurrentUser } from "hooks/useCurrentUser";
import { useFeatureFlags } from "hooks/useFeatureFlags";
import { useMemo } from "react";
import { Navigate, Outlet, matchPath, useLocation, useParams } from "react-router-dom";

export function Waste() {
  const { featureFlags: flags, loading } = useFeatureFlags();
  const { isStaff, loading: userLoading } = useCurrentUser();
  const hasWaste = flags[FeatureFlagKey.WasteModule];

  if (loading || userLoading) {
    return null;
  }

  if (!hasWaste && !isStaff) {
    return <WasteUpsell />;
  }

  if (flags[FeatureFlagKey.LeftNavV2]) {
    return <Outlet />;
  }

  // V1 Nav
  return <WasteOutlet />;
}

export function WasteOutlet() {
  const { featureFlags } = useFeatureFlags();
  const { tenantId } = useParams<{ tenantId: string }>();
  const { pathname } = useLocation();

  const tabs: (TabLink & { shouldRender: boolean })[] = useMemo(
    () => [
      {
        title: "Overview",
        to: tenantId ? `/o/${tenantId}/waste/overview` : "",
        shouldRender: true,
      },
      {
        title: "Waste Facilities",
        to: tenantId ? `/o/${tenantId}/waste/facilities` : "",
        shouldRender: true,
      },
      {
        title: "Manifests",
        to: tenantId ? `/o/${tenantId}/waste/manifests` : "",
        shouldRender: true,
      },
      {
        title: "Manifest Line Items",
        to: tenantId ? `/o/${tenantId}/waste/manifest-line-items` : "",
        shouldRender: true,
      },
      {
        title: "Submissions",
        to: tenantId ? `/o/${tenantId}/waste/submissions` : "",
        shouldRender: featureFlags[FeatureFlagKey.WasteSubmissions],
      },
    ],
    [tenantId, featureFlags]
  );
  const currentTab = tabs.find(({ to }) => matchPath(`${to}/*`, pathname));

  // Redirect to first tab if we don't have a match
  if (!currentTab) {
    return <Navigate to={tabs.filter((tab) => tab.shouldRender)[0].to} replace={true} />;
  }
  const tabIndex = tabs.indexOf(currentTab);

  return (
    <Box>
      <TabLinks
        value={tabs[tabIndex].to}
        tabs={tabs.filter((tab) => tab.shouldRender)}
        aria-label="waste tabs nav"
        role="navigation"
      />
      <Outlet />
    </Box>
  );
}
